import React from 'react'
import { motion } from 'framer-motion'
import { Bike, Zap, Users } from 'lucide-react'

const LoadingScreen: React.FC = () => {
  return (
    <div className="fixed inset-0 bg-black flex items-center justify-center z-50 px-4">
      <div className="text-center max-w-sm sm:max-w-md">
        {/* Logo Animation */}
        <motion.div
          initial={{ scale: 0, rotate: -180 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{ duration: 0.8, type: "spring" }}
          className="mb-6 sm:mb-8"
        >
          <div className="relative">
            <Bike className="w-12 h-12 sm:w-16 sm:h-16 text-white mx-auto" />
            <motion.div
              animate={{ 
                scale: [1, 1.2, 1],
                opacity: [0.5, 1, 0.5]
              }}
              transition={{ 
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut"
              }}
              className="absolute inset-0 bg-accent-400/20 rounded-full blur-xl"
            />
          </div>
        </motion.div>

        {/* Title */}
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.6 }}
          className="text-2xl sm:text-4xl font-bold text-gradient mb-3 sm:mb-4"
        >
          TMC Assist
        </motion.h1>

        {/* Subtitle */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.6 }}
          className="text-gray-300 mb-6 sm:mb-8 text-sm sm:text-base"
        >
          Your comprehensive resource hub
        </motion.p>

        {/* Loading Icons */}
        <div className="flex justify-center space-x-3 sm:space-x-4">
          {[Zap, Users, Bike].map((Icon, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ 
                delay: 0.9 + index * 0.1, 
                duration: 0.5 
              }}
            >
              <motion.div
                animate={{ 
                  y: [0, -10, 0],
                  rotate: [0, 5, -5, 0]
                }}
                transition={{ 
                  duration: 2,
                  repeat: Infinity,
                  delay: index * 0.2
                }}
              >
                <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
              </motion.div>
            </motion.div>
          ))}
        </div>

        {/* Loading Bar */}
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: "100%" }}
          transition={{ duration: 2, ease: "easeInOut" }}
          className="mt-6 sm:mt-8 h-1 bg-white rounded-full max-w-xs mx-auto"
        />
      </div>
    </div>
  )
}

export default LoadingScreen
